module.exports = __webpack_public_path__ + "img/review-11.4555628e.jpg";